"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
exports.__esModule = true;
exports.DsToastAlert = void 0;
require("core-js/modules/es.array.slice.js");
require("core-js/modules/web.timers.js");
var _reactTimeago = _interopRequireDefault(require("react-timeago"));
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DsToastAlert = exports.DsToastAlert = function DsToastAlert(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    title = _ref.title,
    message = _ref.message,
    date = _ref.date,
    selfDismissOn = _ref.selfDismissOn,
    onDismiss = _ref.onDismiss;
  var _useState = (0, _react.useState)(false),
    dismiss = _useState[0],
    setDismiss = _useState[1];
  var titleToDisplay = title ? title : type.charAt(0).toUpperCase() + type.slice(1);
  var handleDismiss = function handleDismiss() {
    setDismiss(true);
    setTimeout(function () {
      onDismiss();
    }, 500);
  };
  if (selfDismissOn && selfDismissOn > 0) {
    setTimeout(handleDismiss, selfDismissOn);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "notification notification-" + type + " mb-2 fade " + (dismiss ? '' : 'show'),
    role: 'alert',
    "aria-live": 'assertive',
    "aria-atomic": 'true',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: 'notification-header',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "fw-medium me-auto",
        children: titleToDisplay
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "notification-timestamp",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTimeago["default"], {
          date: date
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: 'button',
        className: 'btn-close ms-2',
        "aria-label": 'Close',
        onClick: handleDismiss
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: 'notification-body',
      title: message,
      children: message
    })]
  });
};